// extracted by mini-css-extract-plugin
export default {"container":"Countdown_container__b28+J","fadein":"Countdown_fadein__ceY+j","text-container":"Countdown_text-container__ODl75","span-time":"Countdown_span-time__CEPEE"};